import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaApple, FaGooglePlay, FaDesktop } from "react-icons/fa";
import AOS from 'aos';

import Header from '../../components/Header';
import Footer from '../../components/Footer';

// import home2 from '../../assets/images/windintelli/home-2.png';
import highlights1 from '../../assets/images/windintelli_new/highlights-1.png';
import highlights2 from '../../assets/images/windintelli_new/highlights-2.png';
import highlights3 from '../../assets/images/windintelli_new/highlights-3.png';
import highlights4 from '../../assets/images/windintelli_new/highlights-4.png';
// import windintellilogo from '../../assets/images/windintelli/windintelli_logo_white.png';
import windintellilogo from '../../assets/images/logo_windintelli.png';
import windintelliBackground from '../../assets/video/windintelli.mp4';
import windintelliWaiting from '../../assets/images/windintelli_loading.png';
import cmsImg from '../../assets/images/turbine_home.jpg'
import cmsImg2 from '../../assets/images/windintelli_new/highlights-4.png';
import pmsGraphImg from '../../assets/images/smart/pms_info.png';
import pms2Img from '../../assets/images/pms2.jpg';
import pmsMain from '../../assets/images/smart/pms_main.jpg'

import appleStoreIcon from '../../assets/images/destaque/applestore.png';
import googlePlayIcon from '../../assets/images/destaque/googleplay.png';
import browserIcon from '../../assets/images/destaque/browser.png';
import turbineImg from '../../assets/images/destaque/turbine.jpg';
import windintelliImgDestaque from '../../assets/images/destaque/windintelli.jpg';

import "aos/dist/aos.css";
import './styles.css';



function WindIntelli() {
  useEffect(() => {
    AOS.init()
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }, [])
  return (
    <>
      <Header />
      <div className="windintelli-container">
        <div className="background-smart">
          <div className="container">
            <div className="banner-smart content-smart">
              <div className="smart-title">
                <h1>Smart O&M</h1>
                <p>CMS | PMS | App</p>
              </div>
            </div>
          </div>
        </div>
        <div className="background-white">
          <div className="container">
            <div className="content gap-40 section-title">
              <h1>CMS</h1>
              <h2>Condition Monitoring System</h2>
              <p className="pms-text">
              Eólica Tecnologia has a Vibration-based Condition Monitoring System (CMS) on all wind turbines. 
              The targets of the system are reduction of maintenance costs, increase of availability, avoidance of unplanned downtimes, improvement of quality & reliability and extend wind turbine’s lifetime.
              </p>
            </div>
          </div>

          <div className="container">
            <div className="content">
              <div className="pms-highlights">
                <Container>
                  <Row>
                    <Col xs={12} md={12} sm={12} lg={6} >
                      <div className="pms-container-img">
                        <img src={cmsImg} alt="WindIntelli" className="right-40-padding"/>
                      </div>
                      </Col>
                    <Col xs={12} md={12} sm={12} lg={6} className="col-pms-highlights left-40-padding">
                      <p>
                        Wind farms are unlike conventional power stations, the turbines are exposed to harsh weather conditions, including severe winds, high temperature, lightning and thunderstorms. 
                        Due to these external operational conditions, the wind turbines suffer constantly intense mechanical stress with a highly variable operation conditions (speed, load, etc.). 
                        Therefore, a high degree of maintenance is required to provide a safe, cost-effective and reliable power output.
                      </p>
                    </Col>
                  </Row>
                </Container>
              </div>  
            </div>
          </div>

          <div className="container">
            <div className="content">
              <div className="pms-highlights">
                <Container>
                  <Row>
                    <Col xs={12} md={12} sm={12} lg={6} className="col-pms-highlights right-40-padding">
                      <p>
                        Futhermore, Eólica Tecnologia has developed its own online system to treat and analyze automatically a large database from specific vibration data for all main components of the wind turbine. 
                        It works in three main steps: data acquisition using 8 sensors per turbine, signal processing/analysis with various techniques, and daily tracking/diagnosis. 
                        The system is also capable of generating reports and alarms identifying the fault and its location, maximizing reliability of Eólica Tecnologia’s wind farms.
                      </p>
                    </Col>
                    <Col xs={12} md={12} sm={12} lg={6} >
                      <div className="pms-container-img">
                       <img src={cmsImg2} alt="WindIntelli" className="left-40-padding"/>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>  
            </div>
          </div>
          
          <div className="pms-main">
           <img src={pmsMain} alt="PMS" />
          </div>
          <div className="container">
            <div className="content gap-40 section-title">
              <h1>PMS</h1>
              <h2>Performance Monitoring System</h2>
              <p className="pms-text">
                Eólica Tecnologia developed its own Performance Monitoring System (PMS) to optimize the production and reduce O&M costs of its own wind farms. 
              </p>
            </div>
          </div>

          <div className="container">
            <div className="content">
              <div className="pms-highlights">
                <Container>
                  <Row>
                    <Col xs={12} md={12} sm={12} lg={6} >
                      <div className="pms-container-img">
                        <img src={pmsGraphImg} alt="WindIntelli"/>
                      </div>
                    </Col>
                    <Col xs={12} md={12} sm={12} lg={6} className="col-pms-highlights">
                      <p>
                        Maintenance contracts often include availability as its key performance indicator. 
                        A drawback to this approach is that it does not reflect how well the wind turbine performs. 
                        It is common to rely almost exclusively in the intuition of the wind farm operator to elaborate the maintenance planning. 
                        In reality, plenty of factors (such as the expected production, wind turbine failure, etc.) often have a negative effect in the availability of the wind farm and additional maintenance costs occurs.
                      </p>
                    </Col>
                  </Row>
                </Container>
              </div>  
            </div>
          </div>

          <div className="container">
            <div className="content">
              <div className="pms-highlights gap-80">
                <Container>
                  <Row>
                    <Col xs={12} md={12} sm={12} lg={6} className="col-pms-highlights">
                      <p>
                      Eólica Tecnologia developed the Performance Monitoring System (PMS) as an effort to optimize the production and reduce O&M costs of its own wind farms. 
                      Data from the Supervisory Control and Data Acquisition (SCADA) system (which records every possible operational characteristic of the wind turbines) is used as input to the performance monitoring solution. 
                      The data analysis of our PMS system is able to capture the true state of each wind turbine and detect performance issues, which in turn are readily informed to O&M manager that ensures their correction.
                      </p>
                    </Col>
                    <Col xs={12} md={12} sm={12} lg={6} >
                      <div className="pms-container-img">
                        <img src={pms2Img} alt="WindIntelli"/>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>  
            </div>
          </div>
          
        </div>

        <div className="home-windintelli-highlights">
          <video autoPlay muted loop poster={windintelliWaiting} playsInline id="windintelliVideo">
            <source src={windintelliBackground} type="video/mp4" />
          </video>
          <div className="overflow-hidden">
            <div className="container" >
              <Container>
                <Row> 
                  <Col xs={12} md={12} sm={12} lg={12} className="col-home-highlights col-home-highlights-windintelli-page oem-info" data-aos-once="true" data-aos="zoom-in" data-aos-duration="1000">
                    <img src={windintellilogo} alt="logo" />
                    <p>Eólica Tecnologia developed an online platform with automatic fault detection and diagnosis capabilities. <br />
                      The user can manage multiple wind farms worldwide and access anywhere on any device.</p>
                  </Col>
                </Row>
                <Row className="windintelli-download">
                  <Col sm="12" lg="12" className="windintelli-mobile">
                    <div className="overflow-hidden">
                      <Row  data-aos-once="true" data-aos="slide-up" data-aos-duration="1800">
                        <Col lg="12">
                          <div className="windintelli-download-button">
                            <button>
                              <div className="windintelli-button-inside">
                                <a href="https://play.google.com/store/apps/details?id=com.eolicatecnologia.windintelli" target="_blank" rel="noopener noreferrer">
                                  <FaGooglePlay size="22px" />
                                  <div className="windintelli-button-text">
                                    <small>
                                      Download from
                                    </small>
                                    <b>Google Play</b>
                                  </div>
                                </a>
                              </div>
                            </button>
                            <button>
                              <div className="windintelli-button-inside">
                                <a href="https://apps.apple.com/br/app/windintelli/id1470153577" target="_blank" rel="noopener noreferrer">
                                  <FaApple size="22px" />
                                  <div className="windintelli-button-text">
                                    <small>
                                      Download from
                                    </small>
                                    <b>App Store</b>
                                  </div>
                                </a>
                              </div>
                            </button>
                            <button>
                              <div className="windintelli-button-inside">
                                <a href="https://www.windintelli.com" target="_blank" rel="noopener noreferrer">
                                  <FaDesktop size="22px" />
                                  <div className="windintelli-button-text">
                                    <small>
                                      Access from
                                      </small>
                                    <b>Browser</b>
                                  </div>
                                </a>
                              </div>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div> 
        </div>
        
        <div className="background-white">
          <Container className="windintelli-highlights">
            <Row className="windintelli-highlights-container">
              <Col sm="6"  md="6" lg="6">
                <div className="flex-column">
                  <img src={highlights1} alt="highlights"  data-aos-once="true" data-aos="slide-right" data-aos-duration="1000"/>
                </div>
              </Col>
              <Col sm="6" md="6"  lg="6">
                <div className="windintelli-container-text" data-aos-once="true" data-aos="slide-up" data-aos-duration="1500">
                  <h2>Wind Turbine Dashboard</h2>
                  <ul>
                    <li>Individual wind turbine dashboard</li>
                    <li>Key performance indicators in evidence</li>
                    <li>Real power curve versus reference power curve plot</li>
                    <li>Energy production per wind speed bin</li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        
        <div>
          <Container className="windintelli-highlights">
            <Row className="windintelli-highlights-container">
              <Col sm="6"  md="6"  lg="6">
                <div className="windintelli-container-text right-align"  data-aos-once="true" data-aos="slide-right" data-aos-duration="1500">
                  <h2>Alarm Manager</h2>
                  <ul>
                    <li>Downtime events Key Performance Indicators</li>
                    <li>Filter events clicking directly on the chart</li>
                    <li>Energy and financial loss by downtime event type</li>
                    <li>Metrics based on duration and frequency of alarms</li>
                  </ul>
                </div>
              </Col>
              <Col sm="6"  md="6"  lg="6">
                <img src={highlights2} alt="highlights" data-aos-once="true" data-aos="slide-up" data-aos-duration="1000"/>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="background-white">
          <Container className="windintelli-highlights">
            <Row className="windintelli-highlights-container">
              <Col sm="6"  md="6" lg="6">
                <div className="flex-column">
                <img src={highlights3} alt="highlights" data-aos-once="true" data-aos="slide-right" data-aos-duration="1000"/>
                </div>
              </Col>
              <Col sm="6" md="6"  lg="6">
                <div className="windintelli-container-text" data-aos-once="true" data-aos="slide-up" data-aos-duration="1500">
                  <h2>Vibration Overview</h2>
                  <ul>
                    <li>Wind turbine components vibration general data</li>
                    <li>Historical vibration levels heat map</li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div>
          <Container className="windintelli-highlights">
            <Row className="windintelli-highlights-container">
              <Col sm="6" md="6" lg="6">
                <div className="windintelli-container-text right-align" data-aos-once="true" data-aos="slide-right" data-aos-duration="1500">
                  <h2>Spectrum Analysis</h2>
                  <ul>
                    <li>Interactive spectrum plot</li>
                    <li>Wind turbine components main frequencies available</li>
                    <li>Set harmonics and sidebands</li>
                    <li>Automated analysis per frequency band</li>
                  </ul>
                </div>
              </Col>
              <Col sm="6" md="6" lg="6">
                <img src={highlights4} alt="highlights" data-aos-once="true" data-aos="slide-up" data-aos-duration="1000"/>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <div className="work-bg grey-bg  overflow-destaque">
        <div className="container">
          <div className="content">
            <div className="container">
              <Row>
                <Col xs={12} md={6} sm={12} lg={6} className="destaque-turbine">
                  <img src={turbineImg} alt="turbine" />
                </Col>
                <Col xs={12} md={6} sm={12} lg={6} className="destaque-text-section">
                  <div className="destaque-text-box">
                    <h3 className="destaque-text">
                      Would you like to
                    </h3>
                    <h3 className="destaque-text">
                      know more about our
                    </h3>
                    <h3 className="destaque-text-lighter">
                      Online Platform?
                    </h3>
                  </div>
                  <Row className="destaque-icon-row">
                    <Col xs={6} md={4} sm={6} lg={4} className="destaque-icon"  data-aos-once="true" data-aos="slide-left" data-aos-duration="1000" data-aos-delay="200">
                      <a href="https://play.google.com/store/apps/details?id=com.eolicatecnologia.windintelli" target="_blank" rel="noopener noreferrer">
                        <img src={googlePlayIcon} alt="turbine"/> 
                      </a>
                    </Col>
                    <Col xs={6} md={4} sm={6} lg={4} className="destaque-icon"  data-aos-once="true" data-aos="slide-left" data-aos-duration="1000" data-aos-delay="200">
                      <a href="https://apps.apple.com/br/app/windintelli/id1470153577" target="_blank" rel="noopener noreferrer">
                        <img src={appleStoreIcon} alt="turbine" />
                      </a>
                    </Col>
                    <Col xs={6} md={4} sm={6} lg={4} className="destaque-icon"  data-aos-once="true" data-aos="slide-left" data-aos-duration="1000" data-aos-delay="200">
                      <a href="https://www.windintelli.com" target="_blank" rel="noopener noreferrer">
                        <img src={browserIcon} alt="turbine" />
                      </a>
                    </Col>
                    <Col xs={6} md={6} sm={6} lg={6} className="destaque-icon-windintelli"  data-aos-once="true" data-aos="slide-up" data-aos-duration="1000" data-aos-delay="200">
                      <img src={windintelliImgDestaque} alt="turbine" />
                    </Col>
                    <Col xs={12} md={6} sm={12} lg={6} className="destaque-icon-windintelli">
                      &nbsp;
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
    )
}

export default WindIntelli;